import React from "react";
import Chart from "react-google-charts";
import { US_STATES } from "../views/sales/territory-common";

/*
 * US state choropleth (G1 in the Territory & Rep Intelligence spec).
 * Google GeoChart in `regions` display mode — no Maps API key required
 * (only `markers` mode needs one). Rows outside the US state set (Canadian
 * provinces etc. in dealer ship-to data) are excluded from the map; they
 * remain in the accompanying tables.
 *
 * props:
 *   rows      [{ code:'TX', revenue:Number, orders:Number }]  (code = US state,
 *             or ISO-2 country code when scope='world')
 *   metric    'revenue' | 'orders' | 'aov'
 *   scope     'us' (default — US state basemap) | 'world' (country basemap).
 *             World mode still uses `regions` displayMode → no Maps API key.
 *   onSelect  (code) => void   — state (US) or country (world) click-through
 *   height    css height (default '380px')
 *   legendFormat  optional ICU number pattern for the colour-scale legend
 *             (e.g. '$#,##0' so a revenue scale reads in dollars)
 */
export default class GeoChoropleth extends React.Component {
  buildData() {
    const {
      rows,
      metric
    } = this.props;
    const world = this.props.scope === "world";
    const label = this.props.labels && this.props.labels[metric] || (metric === "orders" ? "Orders" : metric === "aov" ? "Avg Order Value" : "Revenue");
    const data = [[world ? "Country" : "State", label]];
    const codes = [];
    (rows || []).forEach(r => {
      const code = String(r.code || "").toUpperCase();
      // US mode: keep known states. World mode: keep ISO-2 country codes.
      if (world ? code.length !== 2 : !US_STATES[code]) return;
      const revenue = Number(r.revenue) || 0;
      const orders = Number(r.orders) || 0;
      let v = revenue;
      if (metric === "orders") v = orders;else if (metric === "aov") v = orders > 0 ? Math.round(revenue / orders) : 0;
      data.push([world ? code : `US-${code}`, Math.round(v * 100) / 100]);
      codes.push(code);
    });
    return {
      data,
      codes
    };
  }
  render() {
    const {
      onSelect,
      height
    } = this.props;
    const world = this.props.scope === "world";
    const {
      data,
      codes
    } = this.buildData();
    if (data.length < 2) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-geo-chart"
    }, /*#__PURE__*/React.createElement(Chart, {
      width: "100%",
      height: height || "380px",
      chartType: "GeoChart",
      data: data,
      options: {
        region: world ? "world" : "US",
        resolution: world ? "countries" : "provinces",
        displayMode: "regions",
        colorAxis: {
          colors: ["#ffeceb", "#ff6358"]
        },
        // coral ramp (--plk-accent-soft → --plk-accent)
        backgroundColor: "transparent",
        datalessRegionColor: "#f0f0f0",
        defaultColor: "#f0f0f0",
        ...(this.props.legendFormat ? {
          legend: {
            numberFormat: this.props.legendFormat
          }
        } : {})
      },
      chartEvents: onSelect ? [{
        eventName: "select",
        callback: ({
          chartWrapper
        }) => {
          try {
            const sel = chartWrapper.getChart().getSelection();
            if (sel && sel.length && typeof sel[0].row === "number") {
              const code = codes[sel[0].row];
              if (code) onSelect(code);
            }
          } catch (e) {/* selection cleared */}
        }
      }] : undefined
    }));
  }
}